import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../api/api";
import "./CategoryPage.css";

export default function StateWiseSubcategory() {
  const { category, stateName } = useParams();
  const decodedCategory = decodeURIComponent(category);
  const decodedState = decodeURIComponent(stateName);

  const [subcategories, setSubcategories] = useState([]);
  const [videoUrl, setVideoUrl] = useState(null);

  // Convert YouTube → embed
  const getEmbedUrl = (url) => {
    try {
      const videoId = new URL(url).searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    } catch {
      return "";
    }
  };

  const loadData = async () => {
    try {
      // Load only schemes allowed for this state
      const res = await API.get(`/states/${encodeURIComponent(decodedState)}`);
      const stateSchemes = res.data.data || [];

      for (const scheme of stateSchemes) {
        // Scheme must be visible in STATE PAGE
        if (!scheme.showInState) continue;

        const matchedCategory = scheme.categories.find(
          (c) => c.name === decodedCategory && c.showInState === true
        );

        if (matchedCategory) {
          // Only include visible subcategories
          const visibleSubs = (matchedCategory.subcategories || []).filter(
            (sub) => sub.showInState === true
          );

          setSubcategories(visibleSubs);
          return;
        }
      }

      setSubcategories([]);

    } catch (err) {
      console.error("Error loading state category data:", err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadData();
  }, [decodedCategory, decodedState]);

  return (
    <div className="category-page-wrapper">
      <div className="category-page-card shadow-lg">
        <h3 className="category-title">
          {decodedCategory} – {decodedState}
        </h3>
        <div className="underline"></div>

        {subcategories.length === 0 ? (
          <p className="no-data">No visible services found for this state.</p>
        ) : (
          <div className="row mt-4">
            {subcategories.map((sub, index) => (
              <div key={index} className="col-lg-4 col-md-4 col-sm-6 mb-4">
                <div className="subcategory-card shadow-sm">
                  <h5 className="name">{sub.name}</h5>

                  <div className="btn-row mt-3">
                    {sub.applyLink && (
                      <a
                        href={sub.applyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn apply-btn"
                      >
                        Apply Online
                      </a>
                    )}

                    {sub.youtubeLink && (
                      <button
                        className="btn video-btn"
                        onClick={() => setVideoUrl(getEmbedUrl(sub.youtubeLink))}
                      >
                        Watch Tutorial
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Video Modal */}
      {videoUrl && (
        <div className="video-modal-overlay" onClick={() => setVideoUrl(null)}>
          <div className="video-modal" onClick={(e) => e.stopPropagation()}>
            <iframe
              width="100%"
              height="350"
              src={videoUrl}
              title="YouTube Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>

            <button
              className="close-btn"
              onClick={() => setVideoUrl(null)}
            >
              X
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
